module.exports = __webpack_public_path__ + "img/chow_typography.c0f090cb.webp";